import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';

function RequestEarlyExitModal({ open, handleClose, mockData, onListClick }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 400,
          bgcolor: 'background.paper',
          borderRadius: '24px',
          boxShadow: 24,
          p: 4,
          outline: 'none',
          maxHeight: '90vh',
          overflowY: 'auto',
        }}>
          {/* Header */}
          <div className="flex items-center mb-6">
            <span onClick={handleClose} className="cursor-pointer text-gray-800 text-[14px] font-bold flex items-center gap-2">
              &larr; Back
            </span>
            <div className="ml-auto">
              <div onClick={handleClose} className="w-8 h-8 rounded-full bg-[#1E222B] text-white flex items-center justify-center cursor-pointer">
                <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L13 13M1 13L13 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </div>

          {/* Illustration placeholder */}
          <div className="text-center mb-6">
            <div className="w-28 h-28 mx-auto bg-[#E8F5E9] rounded-full flex items-center justify-center mb-5">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="3" width="10" height="18" rx="1" stroke="#00BC67" strokeWidth="2"/>
                <rect x="7" y="7" width="4" height="5" rx="0.5" stroke="#00BC67" strokeWidth="1.5"/>
                <circle cx="13" cy="13" r="1" fill="#00BC67"/>
                <path d="M17 8C17 8 19 9 19 12C19 15 17 16 17 16" stroke="#00BC67" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <h2 className="text-[#1E222B] text-[20px] font-bold mb-3">Request early exit</h2>
            <p className="text-[#808285] text-[13px] leading-relaxed px-2">
              you can list your position on the Secondary Market based on the current off plan valuation. if no buyer takes your position before the project completes you will remain invested until the final sale.
            </p>
          </div>

          {/* Position details */}
          <div className="bg-[#F8FAFC] rounded-xl p-4 mb-8">
            <div className="flex justify-between py-2.5">
              <p className="text-[#808285] text-[13px]">Your position</p>
              <p className="text-back-color2 text-[13px] font-bold">{mockData?.units || "0"} units</p>
            </div>
            <div className="flex justify-between py-2.5">
              <p className="text-[#808285] text-[13px]">Original cost per unit</p>
              <p className="text-back-color2 text-[13px] font-bold">{mockData?.originalCostPerUnit || "N/A"}</p>
            </div>
            <div className="flex justify-between py-2.5">
              <p className="text-[#808285] text-[13px]">Current off-plan valuation per unit</p>
              <p className="text-back-color2 text-[13px] font-bold">{mockData?.currentValuationPerUnit || "N/A"}</p>
            </div>
            <div className="flex justify-between py-2.5">
              <p className="text-[#808285] text-[13px]">Estimated position value</p>
              <p className="text-back-color2 text-[13px] font-bold">{mockData?.estimatedPositionValue || "N/A"}</p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex flex-col gap-3">
            <button 
              onClick={onListClick}
              className="w-full py-3.5 bg-[#00BC67] text-white rounded-lg font-[600] text-[15px]"
            >
              List on Secondary Market
            </button>
            <button 
              onClick={handleClose}
              className="w-full py-3 bg-white text-[#00BC67] rounded-lg font-[600] text-[15px]"
            >
              Cancel
            </button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}

export default RequestEarlyExitModal;
